import { createContext, useReducer, useContext, useEffect } from "react";

// Define action types
const ADD_TO_COMPARE = "ADD_TO_COMPARE";
const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";
const CLEAR_COMPARE = "CLEAR_COMPARE";
const LOAD_COMPARE = "LOAD_COMPARE";

// Helper function to get comparison list from localStorage
const getCompareFromStorage = () => {
  if (typeof window !== 'undefined') {
    const storedCompare = localStorage.getItem('compare');
    return storedCompare ? JSON.parse(storedCompare) : [];
  }
  return [];
};

// Compare reducer function
const compareReducer = (state, action) => {
  switch (action.type) {
 
    case ADD_TO_COMPARE:
      if (state.compare.length >= 3) {
        return state; // Prevent adding more than 3
      }
      if (state.compare.find(item => item.id === action.payload.id)) {
        return state; // Prevent duplicates
      }
      return { ...state, compare: [...state.compare, action.payload] };

    case REMOVE_FROM_COMPARE:
      return {
        ...state,
        compare: state.compare.filter(item => item.id !== action.payload.id),
      };

    case CLEAR_COMPARE:
      return { ...state, compare: [] };

    case LOAD_COMPARE:
      return { ...state, compare: action.payload };

    default:
      return state;
  }
};

// Create Context
const CompareContext = createContext();

// CompareProvider component
export const CompareProvider = ({ children }) => {
  const [state, dispatch] = useReducer(compareReducer, { compare: [] }, () => {
    return { compare: getCompareFromStorage() };
  });

  // Sync with localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('compare', JSON.stringify(state.compare));
    }
  }, [state.compare]);

  // Actions
  const addToCompare = (item) => dispatch({ type: ADD_TO_COMPARE, payload: item });
  const removeFromCompare = (item) => dispatch({ type: REMOVE_FROM_COMPARE, payload: item });
  const clearCompare = () => dispatch({ type: CLEAR_COMPARE });

  return (
    <CompareContext.Provider value={{
      compare: state.compare,
      addToCompare,
      removeFromCompare,
      clearCompare
    }}>
      {children}
    </CompareContext.Provider>
  );
};

// Custom Hook for using Compare Context
export const useCompare = () => useContext(CompareContext);